import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { SiteDto } from '@app/admin/models/site-dto';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { buildSiteForm } from './location-form-builder';
import { Store } from '@ngrx/store';
import { SiteState } from '@app/core/store/reducers/site';
import { GetSite, UpdateSite } from '@app/core/store/actions/site.action';
import { getSiteDetail } from '@app/core/store/selectors/site.selector';
import { getResourceState } from '@dwo/selectors';
import { ResourceStatus, ResourceType } from '@dwo/enums';

@Component({
  selector: 'app-edit-location',
  templateUrl: './edit-location.component.html',
  styleUrls: ['./edit-location.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditLocationComponent implements OnInit, OnDestroy {
  private id: string;
  private readonly destroy$ = new Subject<void>();
  form: UntypedFormGroup;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private store: Store<SiteState>,
  ) {}

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('locationId');
    this.store.dispatch(new GetSite(this.id));

    this.store
      .select(getSiteDetail)
      .pipe(
        filter((site) => !!site),
        takeUntil(this.destroy$),
      )
      .subscribe((site) => {
        this.form = buildSiteForm(this.formBuilder, site);
        this.loading = false;
      });

    this.store
      .select(getResourceState, ResourceType.GetSite)
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.loading = state.status === ResourceStatus.InProgress;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onReset() {
    this.store.dispatch(new GetSite(this.id));
  }

  onSave() {
    if (!this.form.valid) {
      return;
    }
    const data = this.form.getRawValue() as SiteDto;
    this.store.dispatch(new UpdateSite(data));
    this.form.markAsPristine();
  }

  onClose() {
    this.router.navigateByUrl(`/admin/locations`);
  }
}
